import React, { useState } from 'react';
import { depoimentos } from '../../data/depoimentos';
import { resultados } from '../../data/resultados';
import './Validacoes.css';

const Validacoes = () => {
  const [filtroAtivo, setFiltroAtivo] = useState('medio');
  const [depoimentosFiltrados, setDepoimentosFiltrados] = useState(depoimentos);

  const filtrarDepoimentos = (categoria) => {
    setFiltroAtivo(categoria);
    if (categoria === 'todos') {
      setDepoimentosFiltrados(depoimentos);
    } else {
      setDepoimentosFiltrados(depoimentos.filter(dep => dep.categoria === categoria));
    }
  };

  return (
    <section id="validacoes" className="section validacoes">
      <div className="container">
        <span className="section-eyebrow">Validação</span>
        <h2 className="section-title">O Que Dizem Nossos Clientes</h2>

        <div className="filtros-depoimentos">
          <button 
            className={`filtro-btn ${filtroAtivo === 'todos' ? 'active' : ''}`}
            onClick={() => filtrarDepoimentos('todos')}
          >
            Todos
          </button>
          <button 
            className={`filtro-btn ${filtroAtivo === 'pequeno' ? 'active' : ''}`}
            onClick={() => filtrarDepoimentos('pequeno')}
          >
            Pequenos Produtores
          </button>
          <button 
            className={`filtro-btn ${filtroAtivo === 'medio' ? 'active' : ''}`}
            onClick={() => filtrarDepoimentos('medio')}
          >
            Médios Produtores
          </button>
          <button 
            className={`filtro-btn ${filtroAtivo === 'grande' ? 'active' : ''}`}
            onClick={() => filtrarDepoimentos('grande')}
          >
            Grandes Produtores
          </button>
        </div>
        
        <div className="depoimentos-container">
          {depoimentosFiltrados.map((depoimento) => (
            <div 
              key={depoimento.id} 
              className="depoimento-card"
              data-role={depoimento.categoria}
            >
              <div className="depoimento-cliente">{depoimento.cliente}</div>
              <div className="depoimento-role">{depoimento.role}</div>
              <div className="depoimento-texto">{depoimento.texto}</div>
            </div>
          ))}
        </div>
        
        <h3 className="resultados-titulo">Resultados Mensuráveis</h3>
        <div className="resultados-container">
          {resultados.map((resultado, index) => (
            <div key={index} className="resultado-card">
              <div className="resultado-porcentagem">{resultado.porcentagem}</div>
              <div className="resultado-descricao">{resultado.descricao}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Validacoes;